import { createSlice } from '@reduxjs/toolkit'

import type { RootState } from '../store'

interface AuthenticationSliceState {
  userInfo: {
    userType?: string
    email?: string
    userId?: string
    [key: string]: unknown
  }
  tokens: string | null
  isCheckingAuthentication: boolean
  isLoggedIn: boolean
}

const initialState: AuthenticationSliceState = {
  userInfo: {},
  tokens: null,
  isCheckingAuthentication: true,
  isLoggedIn: false,
}

const authenticationSlice = createSlice({
  name: 'authentication',
  initialState,
  reducers: {
    signIn(_state, _action) {},
    signInViaIdentityProvider(_state, _action) {},
    checkAuthentication(state, _action) {
      state.isCheckingAuthentication = true
    },
    setAuthenticated(state, { payload }) {
      const { tokens } = payload

      state.isCheckingAuthentication = false
      state.isLoggedIn = !!tokens
      state.tokens = tokens
    },
    setNotAuthenticated(state) {
      state.isCheckingAuthentication = false
    },
    setUserInfo(state, { payload }) {
      state.userInfo = payload
    },
    signOut(state, _action) {
      state.userInfo = {}
    },
  },
})

export const authenticationActions = {
  ...authenticationSlice.actions,
}

export const selectIsCheckingAuthentication = (state: RootState): boolean =>
  state.authentication.isCheckingAuthentication

export const selectIsLoggedIn = (state: RootState): boolean => state.authentication.isLoggedIn

export const selectUserType = (state: RootState): string | undefined =>
  state.authentication.userInfo?.userType

export const selectUserEmail = (state: RootState): string | undefined =>
  state.authentication.userInfo?.email

export const selectUserId = (state: RootState): string | undefined =>
  state.authentication.userInfo?.userId

export default authenticationSlice.reducer
